import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { User } from 'projects/core/src/lib/login/data/user';

@JsonObject('model.NfsSubscriptionType')
export class NfsSubscriptionType extends AbstractModel {

  @JsonProperty(String, 'title')
  title: string;

  @JsonProperty(String, 'value')
  value?: string;
}
